import React from 'react';
import ReactDOM from 'react-dom';
import ErrorBoundary from '../ErrorBoundary';
import UserNavigation from './UserNavigation';
import UserNavigationBackWrapper from './UserNavigationBackWrapper';

class UserNavigationWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            prevUrl: null,
            nextUrl: null
        };
    }

    componentWillMount() {
        this.setState({
            prevUrl: UserNavigation.getPrevious(this.props.userUid),
            nextUrl: UserNavigation.getNext(this.props.userUid)
        });
    }
    render() {
        return this.state.prevUrl || this.state.nextUrl ? (
            <div>
                <a rel="nofollow" className="prev modal-arrows" href={this.state.prevUrl}><span ><i className="fa fa-arrow-circle-left" aria-hidden="true"></i></span></a>
                <a rel="nofollow" className="next modal-arrows" href={this.state.nextUrl}><span ><i className="fa fa-arrow-circle-right" aria-hidden="true"></i></span></a>
            </div>
        ) : null;
    }
}

let UserNavigationWrapperElement = document.getElementsByClassName('UserNavigation');

if (UserNavigationWrapperElement[0]) {
    let userUid = UserNavigationWrapperElement[0].getAttribute('data-userUid');

    ReactDOM.render(
        <ErrorBoundary>
            <UserNavigationWrapper userUid={userUid} />
        </ErrorBoundary>, UserNavigationWrapperElement[0]);
}

let UserNavigationBackWrapperElement = document.getElementsByClassName('UserNavigationBack');

if (UserNavigationBackWrapperElement[0]) {
    let userUid = UserNavigationBackWrapperElement[0].getAttribute('data-userUid');
    let backLang = UserNavigationBackWrapperElement[0].getAttribute('data-backLang');
    

    ReactDOM.render(
        <ErrorBoundary>
            <UserNavigationBackWrapper userUid={userUid} backLang={backLang} />
        </ErrorBoundary>, UserNavigationBackWrapperElement[0]);
}